import { motion } from 'motion/react';
import styled from 'styled-components';

export const Prompt = styled(motion.div)`
  position: fixed;
  right: 20px;
  top: 20px;
  /* Just below the toast stack (999999): a transient toast may briefly pass over this one. */
  z-index: 999998;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 460px;
  max-width: calc(100vw - 40px);
  padding: 16px 18px;
  border-radius: 8px;
  border: 1px solid var(--border-color);
  background: var(--card-background);
  box-shadow:
    0 8px 24px -8px rgba(16, 24, 40, 0.16),
    0 2px 6px -2px rgba(16, 24, 40, 0.08);
  color: var(--main-black);

  [data-theme='dark'] & {
    box-shadow: 0 12px 32px -10px rgba(0, 0, 0, 0.55);
  }

  @media (max-width: 768px) {
    left: 12px;
    right: 12px;
    top: calc(12px + env(safe-area-inset-top, 0px));
    width: auto;
    max-width: none;
  }
`;

/* Text column and the action sit on one row, the button centred against the block of copy. */
export const Body = styled.div`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
`;

export const Text = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const Title = styled.p`
  font-size: var(--font-size-medium);
  font-weight: 600;
  line-height: 1.4;
  overflow-wrap: anywhere;
`;

export const Message = styled.p`
  margin-top: 4px;
  font-size: var(--font-size-medium);
  line-height: 1.45;
  color: var(--text-muted);
  overflow-wrap: anywhere;
`;

export const UpdateButton = styled.button`
  flex: 0 0 auto;
  padding: 9px 16px;
  border: 0;
  border-radius: 8px;
  background: var(--main-black);
  color: var(--main-white);
  font-size: var(--font-size-small);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    opacity: var(--hover-opacity);
  }
`;

/* Leading, not trailing: the screenshot puts dismissal before the message, out of the reading path. */
export const Close = styled.button`
  order: -1;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-top: 1px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--text-tertiary);
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    background: var(--hover-background);
    color: var(--main-black);
  }

  svg {
    width: 15px;
    height: 15px;
  }
`;
